class MyTMap{
    constructor(zoom,center){
        this.map=null;
        this.zoom=zoom || 12;
        this.center=center || {lng:90.996139,lat:29.645230,};
        this.layerType='vector',
        this.infoWindow = null;
    }
    // 初始化地图
    initMap(){
        if(this.map)return;
        let map = new TMap.Map("mapContainer", {
            zoom:this.zoom,
            center: new TMap.LatLng(this.center.lat, this.center.lng),
        });
        map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.ZOOM);//默认移除缩放控件
        map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.ROTATION);//默认移除罗盘控件
        this.map=map;
        this.onMapClick()
    }
    // 地图点击事件
    onMapClick(callBack){
        this.map.on('click',function(e){
            callBack && callBack(e)
        });
    }
    initMarker(data, options){
        this.markerLayer = new TMap.MultiMarker({
            map: this.map,  //指定地图容器
            //点标记数据数组
            styles:{
                [options.styleId]:new TMap.MarkerStyle({
                cursor: "pointer",
                width: options.width || 25,
                height:options.height || 25,
                anchor: { x: 12, y: 12 },
                src: options.src,
              })},
            geometries: data
        });
    }
    markerClick(callBack){
        this.markerLayer.on('click',function(e){
            console.log(e,'markerClick');
            callBack && callBack(e)
        });
    }
    //marker点弹窗
    initInfoWindow(data){
        let param = {
            ...data,
            offset: { x: 0, y: -20 }, //设置信息窗相对position偏移像素
            map: this.map,  //指定地图容器
        }
        this.infoWindow = new TMap.InfoWindow(param)
        // if(this.infoWindow){
        //   this.initInfoWindowClose();
        // }
    }
    initInfoWindowOpen(){
        this.infoWindow.open()
    }
    initInfoWindowClose(){
        this.infoWindow.close()
        this.infoWindow = null;
    }
    // 修改图层
    setBaseMap(type){
        this.map.setBaseMap({type});
        this.getBaseMap();
    }
    // 获取当前地图图层
    getBaseMap(){
       let {type}=this.map.getBaseMap();
       this.layerType=type;
    }
    addMarker(data,options){
        this.initMarker(data,options);
    }
    // 清除所有标记
    removeAllGraphic(){
        if(this.markerLayer){
            this.markerLayer.setGeometries([])
        }
    }
    // 清除指定标记
    /**
     * @param {Array} data 
     */
    remove(data){
        if(this.markerLayer && data){
            this.markerLayer.remove(data)
        }
    }

}
export {
    MyTMap
}